import { getSortOrder } from 'packages/common/utils/utils';
import cepService from 'packages/common/services/cepService';
import internResource from '../../resource';

export function getInterns({ pagination = {}, sort = {}, searchTerm }) {
  return internResource.getInterns({
    page: pagination?.page - 1,
    size: pagination?.pageSize,
    sortBy: sort?.sortBy,
    sortOrder: getSortOrder(sort?.sortOrder),
    search: searchTerm,
  }).then(response => response.data);
}

export function getIntern(id) {
  return internResource.getIntern(id).then(response => response.data);
}

export function createNewIntern(intern) {
  return internResource.createNewIntern(intern);
}

export function editIntern(id, intern) {
  return internResource.editIntern(id, intern);
}

export function deleteIntern(id) {
  return internResource.deleteIntern(id);
}

export function getCepInformation(cep) {
  return cepService.getCepInformation(cep);
}
